interface IWhitenessOptions {
  // Dark-pixel fraction below which the image reads as mostly white. Default 0.5.
  threshold?: number
  // Channel value (0-255) under which a pixel counts as dark. Default 240.
  maxBrightness?: number
  // Alpha (0-255) under which a pixel is transparent and ignored. Default 10.
  maxAlpha?: number
}

// Shared decision for "does this logo read as white on a light surface" — true
// when too few visible pixels are dark (or none are visible). Callers draw the
// image their own way (the map chip downscales to a fixed SVG-safe box, the
// navbar uses native size) and hand over the resulting pixel data.
export function isMostlyWhiteImageData(
  data: Uint8ClampedArray,
  {
    threshold = 0.5,
    maxBrightness = 240,
    maxAlpha = 10,
  }: IWhitenessOptions = {},
): boolean {
  let visiblePixels = 0
  let darkPixels = 0
  for (let i = 0; i < data.length; i += 4) {
    if (data[i + 3] < maxAlpha) continue
    visiblePixels++
    if (
      data[i] < maxBrightness ||
      data[i + 1] < maxBrightness ||
      data[i + 2] < maxBrightness
    ) {
      darkPixels++
    }
  }
  return visiblePixels === 0 || darkPixels / visiblePixels < threshold
}
